export const PLAYER_OFF_LABEL = 'Player Off';
export const PLAYER_ON_LABEL = 'Player On';
